export default class SearchCriteria {
    constructor() {
        this.SearchType = "";
        this.BeginDate = null;
        this.EndDate = null;
        this.LicenseNumber = "";
        this.FirstName = null;
        this.MiddleName = null;
        this.LastName = null;
    }
}